import { type ReconnectEvent } from '../../../network-state-machine-events.ts';

export async function closedAsync(): Promise<ReconnectEvent> {
  return {
    type: 'reconnect',
  };
}
